import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import dayjs from "dayjs";

import { withRequest } from "../../../utils/request";
import { formatCurrency, formatNumber } from "../../../utils/helpers";
import { auth } from "../../../utils/auth";

class Resumen extends Component {
    state = {
        nominas: [{ pagos: [] }],
    };
    componentDidMount() {
        this.getNomina();
    }
    getNomina = async (url = null) => {
        const id = this.props.match.params.id;
        const search = window.location.search ? window.location.search : "";
        url = url ? url : "nominas/" + id + search;
        const nominas = await this.props.request(url);

        if (nominas.success) {
            this.setState({
                nominas: nominas.data,
            });
            //window.print();
        }
    };
    render() {
        const { nominas } = this.state;

        const user = auth.getUser();
        const sucursal = user.sucursales.filter(
            (suc) => suc.id === user.sucursalActual
        )[0];
        const query = queryString.parse(window.location.search);
        const nomina = nominas[0];

        const pagos = nominas.reduce((acc, nom) => {
            acc = [...acc, ...nom.pagos];
            return acc;
        }, []);

        console.log(pagos);

        const empleadosCombinados = pagos.reduce((acc, empleado) => {
            if (acc[empleado.cedula] === undefined) {
                acc[empleado.cedula] = empleado;
            } else {
                acc[empleado.cedula].toneladas =
                    parseFloat(acc[empleado.cedula].toneladas) +
                    parseFloat(empleado.toneladas);
                acc[empleado.cedula].total =
                    parseFloat(acc[empleado.cedula].sueldoBruto) +
                    parseFloat(empleado.sueldoBruto);
                acc[empleado.cedula].sueldoBruto =
                    parseFloat(acc[empleado.cedula].sueldoBruto) +
                    parseFloat(empleado.sueldoBruto);
            }
            return acc;
        }, {});

        const empleados = Object.keys(empleadosCombinados)
            .sort((a, b) => {
                return empleadosCombinados[a].nombre <
                    empleadosCombinados[b].nombre
                    ? -1
                    : 1;
            })
            .reduce((acc, empleado) => {
                const emp = empleadosCombinados[empleado];
                if (acc[emp.cargo] === undefined) {
                    acc[emp.cargo] = [emp];
                } else {
                    acc[emp.cargo].push(emp);
                }
                return acc;
            }, {});

        const totalEmpleados = nominas.reduce((acc, nomina) => {
            return parseInt(nomina.empleados) + acc;
        }, 0);

        const totalPagos = nominas.reduce((acc, nomina) => {
            return parseInt(nomina.total) + acc;
        }, 0);

        return (
            <div>
                <div className='row'>
                    {nomina.cerradaEn && (
                        <div className='fecha_cierre col-md-12'>
                            Nomina Cerrada:{" "}
                            {dayjs(nomina.cerradaEn).format("DD/MM/YYYY")}
                        </div>
                    )}
                    <h2 className='col-md-12 text-center m-b-5'>
                        Resumen de Nómina{" "}
                        {query.contrato === "informal" ? "Informales" : ""}
                    </h2>
                    <div className='col-md-12 text-center'>
                        {sucursal.nombre} - {sucursal.direccion} •{" "}
                        {dayjs(nomina.fechaInicio).format("DD/MM/YYYY")} -{" "}
                        {dayjs(nomina.fechaCierre).format("DD/MM/YYYY")}
                    </div>
                    <div className='col-md-12 p-b-10'></div>
                    <div className='col-md-12 text-right p-b-10'>
                        <div className='float-left'>
                            EMPLEADOS: {totalEmpleados}
                        </div>

                        <div className='float-right'>
                            <h3>GASTO TOTAL: {formatCurrency(totalPagos)}</h3>
                        </div>
                    </div>
                </div>
                {Object.keys(empleados).map((key) => {
                    const subtotalSueldoBruto = empleados[key].reduce(
                        (acc, empleado) => {
                            return acc + parseFloat(empleado.sueldoBruto);
                        },
                        0
                    );

                    const subtotalDescuentos = empleados[key].reduce(
                        (acc, empleado) => {
                            return acc + parseFloat(empleado.totalDescuentos);
                        },
                        0
                    );

                    const subtotal = empleados[key].reduce((acc, empleado) => {
                        return acc + parseFloat(empleado.sueldoBruto - empleado.totalDescuentos);
                    }, 0);
                    return (
                        <div key={empleados[key][0].cargo}>
                            <h3>
                                <div className='float-left'>
                                    TIPO EMPLEADO: {empleados[key][0].cargo} -
                                    EMPLEADOS: {empleados[key].length}
                                </div>
                                <div className='float-right'>
                                    TOTAL:
                                    {formatCurrency(subtotal)}
                                </div>
                            </h3>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th>Cargo</th>
                                        <th className='text-center'>
                                            Toneladas
                                        </th>
                                        <th className='text-right'>
                                            Sueldo Fijo
                                        </th>
                                        <th className='text-right'>
                                            Sueldo Bruto
                                        </th>
                                        <th className='text-right'>
                                            Descuentos
                                        </th>
                                        <th className='text-right'>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {empleados[key].map((empleado, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{empleado.codigo}</td>
                                                <td>{empleado.nombre}</td>
                                                <td>{empleado.cargo}</td>
                                                <td className='text-center'>
                                                    {formatNumber(
                                                        empleado.toneladas
                                                    )}
                                                </td>
                                                <td className='text-right'>
                                                    {formatCurrency(
                                                        parseFloat(
                                                            empleado.sueldoFijo
                                                        )
                                                    )}
                                                </td>
                                                <td className='text-right'>
                                                    {formatCurrency(
                                                        empleado.sueldoBruto
                                                    )}
                                                </td>
                                                <td className='text-right'>
                                                    {formatCurrency(
                                                        empleado.totalDescuentos
                                                    )}
                                                </td>
                                                <td className='text-right'>
                                                    {formatCurrency(
                                                        empleado.sueldoBruto - empleado.totalDescuentos
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    <tr style={{ fontWeight: "bold" }}>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>TOTALES =></td>
                                        <td className='text-right'>
                                            {formatCurrency(
                                                subtotalSueldoBruto
                                            )}
                                        </td>
                                        <td className='text-right'>
                                            {formatCurrency(subtotalDescuentos)}
                                        </td>
                                        <td className='text-right'>
                                            {formatCurrency(subtotal)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    );
                })}
                <div className='row'>
                    <div className='col-md-12 text-right p-b-10'>
                        <div className='float-left'>
                            EMPLEADOS: {totalEmpleados}
                        </div>

                        <div className='float-right'>
                            <h3>GASTO TOTAL: {formatCurrency(totalPagos)}</h3>
                        </div>
                    </div>
                </div>
                <div className='firma-reporte'>
                    <div className='firma'>Supervisor</div>
                </div>
            </div>
        );
    }
}

export default withRouter(withRequest(Resumen));
